import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  Topping,
  ToppingSelectable,
} from 'src/app/main/backoffice/modules/pedidos/models/crearPedido.dto';
import { ProductosService } from 'src/app/main/backoffice/modules/productos/services/productos.service';

export interface Extra {
  nombre: string;
  precio: number;
  seleccionado: boolean;
}

@Component({
  selector: 'app-producto-editor-dialog',
  templateUrl: './producto-editor-dialog.component.html',
  styleUrls: ['./producto-editor-dialog.component.scss'],
})
export class ProductoEditorDialogComponent {
  toppings: ToppingSelectable[] = [];
  loading = false;
  total = 0;

  constructor(
    private productosService: ProductosService,
    @Inject(MAT_DIALOG_DATA) public item: any,
    private dialogRef: MatDialogRef<ProductoEditorDialogComponent>,
  ) {}

  ngOnInit(): void {
    if (!this.item.cantidad) this.item.cantidad = 1;
    if (!this.item.extras) this.item.extras = [];
    this.cargarToppings();
  }

  /** OBTIENE TOPPINGS DEL BACKEND */
  cargarToppings(): void {
    this.loading = true;

    this.productosService.obtenerToppings({ isAvailable: true }).subscribe({
      next: (res) => {
        this.toppings = res.map((t) => ({
          ...t,
          seleccionado: this.item.extras?.some((e: Topping) => e.id === t.id),
        }));

        this.loading = false;
        this.calcularTotal();
      },
      error: () => (this.loading = false),
    });
  }

  /** CAMBIAR CANTIDAD */
  cambiarCantidad(amount: number): void {
    const nuevaCantidad = this.item.cantidad + amount;
    if (nuevaCantidad >= 1) {
      this.item.cantidad = nuevaCantidad;
      this.calcularTotal();
    }
  }

  /** TOGGLE TOPPING */
  toggleTopping(topping: ToppingSelectable): void {
    topping.seleccionado = !topping.seleccionado;
    this.calcularTotal();
  }

  /** CALCULA TOTAL */
  calcularTotal(): void {
    const extrasTotal = this.toppings
      .filter((t) => t.seleccionado)
      .reduce((sum, t) => sum + t.price, 0);

    this.total = this.item.precioBase * this.item.cantidad + extrasTotal;
  }

  /** GUARDAR */
  guardar(): void {
    const extrasSeleccionados = this.toppings
      .filter((t) => t.seleccionado)
      .map(({ seleccionado, ...t }) => t);

    this.dialogRef.close({
      ...this.item,
      extras: extrasSeleccionados,
      total: this.total,
    });
  }
}
